import React, { useState, useEffect, useRef } from "react";

import { withRouter, Link } from "react-router-dom";

import { getUserName } from "../../services/auth";

import Layout from "../../components/Layout";

import {apiCRMv3} from "../../services/api";

const DashCRM = (props) => {
    const [loaded, setLoaded] = useState(false);
    const [birthdaySended, SetBirthdaySended] = useState("")
    const [buyIntentionSended, SetBuyIntentionSended] = useState("")
    const [clientListSended, setClientListSended] = useState("")
    const [easyBuySended, setEasyBuySended] = useState("")
    const [eligibleWarrantySended, setEligibleWarrantySended] = useState("")
    const [lostClickSended, setLostClickSended] = useState("")
    const [rightTimeSended, setRightTimeSended] = useState("")
    const [smartListSended, setSmartListSended] = useState("")

    useEffect(function () {
        loadData()
    }, []);

    async function loadData() {
        setLoaded(false);

        try {
            await Promise.all([
                getBirthdasSended(),
                getBuyIntentionSended(),
                getClientListSended(),
                getEasyBuySended(),
                getEligibleWarrantySended(),
                getLostClickSended(),
                getRigthTimeSended(),
                getSmartListSended()
                
            ]);
        } catch (error) {
            console.error("Erro ao carregar os dados:", error);
        } finally {
            setLoaded(true);
        }
    }

    async function getBirthdasSended() {
        const response = await apiCRMv3.get("/birthdays/get-sent-today");
        
        SetBirthdaySended(response.data.data.birthdaySendedsCount)
    }

    async function getBuyIntentionSended() {
        const response = await apiCRMv3.get("/purchase-intentions/get-sent-today");
        
        SetBuyIntentionSended(response.data.data.buyIntentionSendedsCount)
    }

    async function getClientListSended() {
        const response = await apiCRMv3.get("/clients-list/get-sent-today");
        
        setClientListSended(response.data.data.clientListSendedsCount)
    }

    async function getEasyBuySended() {
        const response = await apiCRMv3.get("/easy-shopping/get-sent-today");
        
        setEasyBuySended(response.data.data.easyBuySendedsCount)
    }

    async function getEligibleWarrantySended() {
        const response = await apiCRMv3.get("/eligible-guarantees/get-sent-today");
        
        setEligibleWarrantySended(response.data.data.eligibleWarrantySendedsCount)
    }

    async function getLostClickSended() {
        const response = await apiCRMv3.get("/lost-clicks/get-sent-today");
        
        setLostClickSended(response.data.data.lostClickSendedsCount)
    }

    async function getRigthTimeSended() {
        const response = await apiCRMv3.get("/right-hours/get-sent-today");
        
        setRightTimeSended(response.data.data.rigthTimeSendedsCount)
    }

    async function getSmartListSended() {
        const response = await apiCRMv3.get("/smart-list/get-sent-today");
        
        setSmartListSended(response.data.data.smartListSendedsCount)
    }

    return (
        <Layout menuActive="envios-crm-hoje" pageTitle="Envios CRM">
            <div className="row">
                <div className="col-xs-12">
                    <div className="card card-mini">
                        <div className="card-header">
                            <div className="card-title">
                                <h1>Olá, {getUserName()}</h1>
                                <small>Resumo dos envios de hoje</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* Aniversariantes */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-blue-light">
                        <div className="card-body">
                            <i className="icon fa fa-birthday-cake fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Aniversariantes enviados hoje
                                </div>

                                <div className="value">
                                    {birthdaySended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Funil 2.0 */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-green-light">
                        <div className="card-body">
                            <i className="icon fa fa-filter fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Funil 2.0 enviados hoje
                                </div>

                                <div className="value">
                                    {clientListSended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Intenções de compra */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-yellow-light">
                        <div className="card-body">
                            <i className="icon fa fa-shopping-cart fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Intenções de compra enviadas hoje
                                </div>

                                <div className="value">
                                    {buyIntentionSended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* Pagando Ultimas Parcelas */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-blue-light">
                        <div className="card-body">
                            <i className="icon fa fa-credit-card fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Pagando Ultimas Parcelas  enviadas hoje
                                </div>

                                <div className="value">
                                    {easyBuySended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Garantias Elegiveis */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-green-light">
                        <div className="card-body">
                            <i className="icon fa fa-check-circle fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Garantias  enviadas hoje
                                </div>

                                <div className="value">
                                    {eligibleWarrantySended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Remarketing */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-yellow-light">
                        <div className="card-body">
                            <i className="icon fa fa-bullseye fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Remarketings enviados hoje
                                </div>

                                <div className="value">
                                    {lostClickSended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* Inativos */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-blue-light">
                        <div className="card-body">
                            <i className="icon fa fa-user-times fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Inativos enviados hoje
                                </div>

                                <div className="value">
                                    {rightTimeSended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Smart List */}
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-green-light">
                        <div className="card-body">
                            <i className="icon fa fa-send fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Lista Ativas enviadas hoje
                                </div>

                                <div className="value">
                                    {smartListSended ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Pós-venda */}
                {/* <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="card card-banner card-yellow-light">
                        <div className="card-body">
                            <i className="icon fa fa-headphones fa-4x"></i>

                            <div className="content">
                                <div className="title">
                                    Pós-venda enviados hoje
                                </div>

                                <div className="value">
                                    {1 ?? 0}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </Layout>
    );
};

export default withRouter(DashCRM);
